import { includes } from 'lodash';

import { DriverCompanyStateTypes } from '~globals/types/enums';
import { DriverImporter } from '~services/admin/driver/types';
import { Driver, DriverCompanyBase } from '~services/driver/types';
import { pluralize } from '~utils/commons';

export const validateDriverCompanyState = (
  state: DriverCompanyStateTypes,
  validStates: DriverCompanyStateTypes[],
): boolean => includes(validStates, state);

export const isNotPendingDriver = (state: DriverCompanyStateTypes): boolean =>
  validateDriverCompanyState(state, [
    DriverCompanyStateTypes.Approve,
    DriverCompanyStateTypes.Rejected,
  ]);

export const isApprovedDriver = (state: DriverCompanyStateTypes): boolean =>
  validateDriverCompanyState(state, [DriverCompanyStateTypes.Approve]);

export const getImporterDriversFromCSVAlertDescription = ({
  importedRows,
  totalRows,
  errorRows,
}: DriverImporter): string | string[] => {
  let text: string | string[] = `Se ${pluralize({
    singular: 'importó',
    plural: 'importaron',
    count: importedRows,
  })} ${pluralize({
    singular: 'chofer',
    plural: 'choferes',
    count: importedRows,
    includeCount: true,
  })} correctamente`;

  if (errorRows >= 1) {
    const sendCustomersText = `Se ${pluralize({
      singular: 'envió',
      plural: 'enviaron',
      count: totalRows,
    })} ${pluralize({
      singular: 'chofer',
      plural: 'choferes',
      count: totalRows,
      includeCount: true,
    })}`;

    const successCustomersImported = ` ${importedRows} se ${pluralize({
      singular: 'importó',
      plural: 'importaron',
      count: importedRows,
    })} correctamente`;

    const errorsCustomersImported = `${errorRows} se ${pluralize({
      singular: 'importó',
      plural: 'importaron',
      count: errorRows,
    })} con errores`;

    text = [
      sendCustomersText,
      successCustomersImported,
      errorsCustomersImported,
    ];
  }

  return text;
};

export const convertDriverUserToDriverCompanyBase = (
  currentDriver: Driver,
): DriverCompanyBase => ({
  id: currentDriver.userId,
  displayName: `${currentDriver.lastName}, ${currentDriver.firstName}`,
  avatar: currentDriver.avatarFile?.url ?? null,
  code: currentDriver.code,
  enabled: currentDriver.enabled,
  isAvailable: true,
});
